module.exports = __webpack_public_path__ + "img/838b415b33a70b1c99f2480fc0e654fb.69581085.jpg";